var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"phone-audio-bars"},_vm._l((_vm.heights),function(height,i){return _c('rect',{key:i,attrs:{"rx":"4","height":20*height,"width":"4","x":i*6,"y":10-(height*10),"fill":"#4a4a4a"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }